export const formInitialValues = (data) => ({
  keterangan: data?.keterangan ?? "",
  namaKategori: data?.nama_kategori_anggaran ?? "",
  idKategori: data?.id_kategori_anggaran ?? "",
});
